/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main[_ngcontent-%COMP%]{padding-bottom:6rem}.main[_ngcontent-%COMP%]   .contact-us-page-container[_ngcontent-%COMP%]{min-width:1200px;padding:0 5rem}.main[_ngcontent-%COMP%]   .contact-us-page-container[_ngcontent-%COMP%]   .page-title[_ngcontent-%COMP%]{padding:1rem 2rem 2rem 2rem;font:1.6rem PoppinsThin,sans-serif}.main[_ngcontent-%COMP%]   .contact-us-page-container[_ngcontent-%COMP%]   .profile-container[_ngcontent-%COMP%]{padding:0}.main[_ngcontent-%COMP%]   .contact-us-page-container[_ngcontent-%COMP%]   .profile-container[_ngcontent-%COMP%]   .profile[_ngcontent-%COMP%]{width:100%;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:center;align-items:center;text-align:center}"];
export { styles as styles };
//# sourceMappingURL=contact-us-faqs.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/contact-us/contact-us-page-faqs/contact-us-faqs.component.scss.shim.ngstyle.js
// module id = 1648
// module chunks = 26 27 28